import { createConsumer, type Consumer } from '@rails/actioncable'

let consumer: Consumer | null = null

export function getCableConsumer(): Consumer {
  if (consumer) return consumer
  consumer = createConsumer('/cable')
  return consumer
}
